import { connect } from 'react-redux';
import { setAllCookiesAccepted } from '../../publicSession/actions';
const mapDispatchToProps = {
    onAccept: setAllCookiesAccepted
};
export default connect(null, mapDispatchToProps);
